import React, { useState } from "react";
import "./ProjectCard.css";
import newsticker from "../assets/newsticker.gif";

const ProjectCard = (props) => {
  const [isHover, setIsHover] = useState(true);
  return (
    <div
      className="project-card"
      onClick={() => {
        window.open(props.source_link, "_blank");
      }}
    >
      {isHover && props.new && (
        <img id="gif-card" src={newsticker} alt="Your GIF" />
      )}
      <img
        src={props.image}
        alt=""
        onMouseEnter={() => {
          setIsHover(false);
        }}
        onMouseLeave={() => {
          setIsHover(true);
        }}
      />
      <div className="card-description">
        <h3>{props.title}</h3>
        <p>{props.description}</p>
        <div className="stacks">
          {props.stacks.map((stack, id) => (
            <button className="tech-stack" key={id}>
              {stack}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
